import type { QueryKey } from 'react-query';
import { queryKeys } from 'src/queries/keys';

const NEVER_PERSISTED_ROOTS: ReadonlySet<unknown> = new Set([
  queryKeys.notifications()[0],
  queryKeys.unreadNotifications()[0],
  queryKeys.vsaqConversations()[0],
  queryKeys.tutorHistoryList()[0],
]);

const CORE_ROOTS: ReadonlySet<unknown> = new Set([
  queryKeys.user()[0],
  queryKeys.users()[0],
  queryKeys.wallet()[0],
  queryKeys.streak()[0],
]);

export const isPersistedQueryKey = (queryKey: QueryKey): boolean =>
  !NEVER_PERSISTED_ROOTS.has(queryKey[0]);

export const isCoreQueryKey = (queryKey: QueryKey): boolean =>
  CORE_ROOTS.has(queryKey[0]) && queryKey.length === 1;
